import { Tabs } from '@chakra-ui/react';
import { TabsList } from 'components/elements/TabsList';
import { FlexRow } from 'components/layout/FlexRow';
import {
  ALL_PROJECTS_TABLE_VIEW_TYPE,
  type ListViewMode,
} from 'components/widgets/Dashboard/CompanyGroups/companyGroupTableViewMode';

const TAB_LABELS = ['Companies', 'All projects'];

type Props = {
  mode: ListViewMode;
  onChange: (index: number) => void;
};

const CompanyGroupViewModeToggle = ({ mode, onChange }: Props) => (
  <FlexRow>
    <Tabs
      variant="enclosed"
      index={mode === ALL_PROJECTS_TABLE_VIEW_TYPE ? 1 : 0}
      onChange={onChange}
    >
      <FlexRow>
        <TabsList tabLabels={TAB_LABELS} />
      </FlexRow>
    </Tabs>
  </FlexRow>
);

export default CompanyGroupViewModeToggle;
